import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";

import { Provider, getServerData, getTemplate } from "@reactivated";

import { activateTranslations } from "@thelabnyc/thelabui/src/utils/i18n";

import { FavoritesToastRegion } from "./components/FavoritesToastRegion";
import { SuiteStateProvider } from "./components/SuiteBuilder/SuiteState/SuiteState";
import { TranscendAirgapLoader } from "./components/TranscendAirgapLoader";
import { FavoritesProvider } from "./favorites";

const { props, context } = getServerData();

const SCRUBBED_KEYS = ["forwarded", "-ip", "remote-", "via", "-user"];

if (context.SENTRY_DSN) {
    Sentry.init({
        // v11 widened the defaults; keep v10's (sendDefaultPii off) collection.
        dataCollection: {
            userInfo: false,
            cookies: false,
            httpHeaders: {
                request: { deny: SCRUBBED_KEYS },
                response: { deny: SCRUBBED_KEYS },
            },
            httpBodies: [],
            urlQueryParams: { deny: SCRUBBED_KEYS },
            genAI: { inputs: false, outputs: false },
            databaseQueryData: false,
            queues: false,
            graphQL: { document: false, variables: false },
        },
        dsn: context.SENTRY_DSN,
        release: context.CI_COMMIT_SHA,
        environment: context.CI_COMMIT_REF_SLUG,
        integrations: [],
        // Filter errors originating from third-party tracking scripts
        // https://thelab.sentry.io/issues/SKS-CMS-JF
        denyUrls: [/ct\.pinterest\.com/i],
    });
}

activateTranslations(context.i18n);

const main = async () => {
    const Template = await getTemplate(context);

    ReactDOM.hydrateRoot(
        document,
        <React.StrictMode>
            <Provider value={context}>
                <FavoritesProvider>
                    <SuiteStateProvider>
                        <TranscendAirgapLoader />
                        <Template {...props} />
                        <FavoritesToastRegion />
                    </SuiteStateProvider>
                </FavoritesProvider>
            </Provider>
        </React.StrictMode>,
    );
};

await main();
